import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { DeviceSyncStatus } from '@era/locations-sdk';
import { Store } from '@ngrx/store';
import { DeviceSyncStatusComponent } from './device-sync-status.component';
import { AsyncPipe } from '@angular/common';
import { DeviceSyncStatusSelectors } from '../../sub-features/device-sync/device-sync-statuses-store';

@Component({
  selector: 'era-device-sync-status',
  templateUrl: './device-sync-status.container.html',
  styleUrls: ['./device-sync-status.container.scss'],
  imports: [DeviceSyncStatusComponent, AsyncPipe],
})
export class DeviceSyncStatusContainerComponent {
  public readonly deviceStatus$: Observable<DeviceSyncStatus>;

  constructor(private readonly deviceSyncStatusStore: Store<DeviceSyncStatus>) {
    this.deviceStatus$ = this.deviceSyncStatusStore.select(DeviceSyncStatusSelectors.selectCurrentDeviceSyncStatus);
  }
}
